import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW5500Model } from './kymw5500.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FlexGrid, SelectionMode } from '@grapecity/wijmo.grid';
import { GetImageFileListService } from './api-services/get-image-file-list.service';
import { UpdateImageFileListService } from './api-services/update-image-file-list.service';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { KYMW0D00InputModel } from '../../../commons/kymw0d/kymw0d00/vo/kymw0d00-input.model';
import { KYMW0D00Component } from '../../../commons/kymw0d/kymw0d00/kymw0d00.component';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';

/**
 * EC画像メンテ画面を管理するクラス
 *
 * @export KYMW5500Component
 * @class KYMW5500Component
 */
@Component({
  selector: 'app-kymw5500',
  templateUrl: 'kymw5500.component.html',
  styleUrls: ['kymw5500.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW5500Component extends PlessViewHelperSub implements OnInit {
  // 親画面からの連携値
  param: any;

  kymw5500Model: KYMW5500Model = new KYMW5500Model();

  @ViewChild('dtg_ImageFileList', { static: true }) dtg_ImageFileList: FlexGrid;

  @ViewChild('btn_UpdateImage', { static: true }) btn_UpdateImage: ElementRef;
  @ViewChild('img_Publish', { static: true }) img_Publish: ElementRef;
  @ViewChild('img_CwsBefore', { static: true }) img_CwsBefore: ElementRef;
  @ViewChild('img_CwsAfter', { static: true }) img_CwsAfter: ElementRef;

  selfManage: KYMW5500Model;

  /**
   * Creates an instance of KYMW5500Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW5500Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getImageFileListService: GetImageFileListService,
    private updateImageFileListService: UpdateImageFileListService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW5500';
    this.kymw5500Model.kymw5500Component = this;

    // 行ヘッダの幅を0にしてレイアウト設定
    this.dtg_ImageFileList.rowHeaders.columns[0].width = 0;
    this.dtg_ImageFileList.selectionMode = SelectionMode.Row;

    this.dtg_ImageFileList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_ImageFileList.select(-1, -1);

      // 活性・非活性制御処理
      this.plessEnabledSetting();
    });

    // サーバに画像ファイル一覧取得を要求
    this.getImageFileListService.execute(this.kymw5500Model);

    setTimeout(() => {
      // 活性・非活性制御処理
      this.plessEnabledSetting();
      this.dtg_ImageFileList.focus();
    });
  }

  /**
   * 活性・非活性制御処理
   *
   * @memberof KYMW5500Component
   */
  public plessEnabledSetting(): void {
    if (!PlessViewUtilsSub.isEmptyArray(this.kymw5500Model.imageFileList)) {
      this.plessEnabled(this.btn_UpdateImage, true);
    } else {
      this.plessEnabled(this.btn_UpdateImage, false);
    }
  }

  /**
   * 画像ファイル一覧 選択変更時イベント
   */
  public eventImageFileListSelect_CHANGEHandler(): void {
    if (this.dtg_ImageFileList.selection.row < 0) {
      this.img_Publish.nativeElement.src = '';
      this.img_CwsBefore.nativeElement.src = '';
      this.img_CwsAfter.nativeElement.src = '';
    } else {
      this.img_Publish.nativeElement.src = this.dtg_ImageFileList.selectedItems[0].PublishImageUrl;
      this.img_CwsBefore.nativeElement.src = this.dtg_ImageFileList.selectedItems[0].CwsBeforeImageUrl;
      this.img_CwsAfter.nativeElement.src = this.dtg_ImageFileList.selectedItems[0].CwsAfterImageUrl;
    }
  }

  /**
   * 更新ボタン押下イベント
   */
  public eventUpdateImage_CLICKHandler(): void {
    // 更新対象データ存在チェック
    if (PlessViewUtilsSub.isEmptyArray(this.kymw5500Model.getUpdateImageFileListVo().imageFileList)) {
      this.dialogService.openAlertGetMessage('E0111', ['画像']);
      return;
    }

    // 更新確認メッセージを表示
    this.dialogService.openAlertGetMessage('Q0105', ['画像ファイル'],
      (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          this.eventUpdateMessageClose();
        }
      }
    );
  }

  /**
   * 更新確認メッセージ選択後処理
   */
  public eventUpdateMessageClose(): void {
    // // サーバに画像ファイル更新を要求
    const vo: {
      ImageId: '',
      ImageFileName: '',
      ImagePathId: '',
    } = this.kymw5500Model.getUpdateImageFileListVo();
    this.updateImageFileListService.execute(this.kymw5500Model, vo);
  }

  /**
   * 処理ログ画面を呼び出す(サーバー処理後、Commandから呼び出される)
   * @param serverData サーバ取得データ
   */
  public popupLog(serverData: any, dataDiv: string): void {
    // 処理ログ画面を呼び出す。
    // 取込処理ログ検索条件を保持したVOを作成し、画面を呼び出す。
    // 「インプットVO」の生成

    const vo: KYMW0D00InputModel = new KYMW0D00InputModel();
    // 画面ＩＤ
    vo.dispId = 'KYMW5500';
    // データ区分
    vo.dataDiv = dataDiv;
    // 正常件数
    vo.normalNum = serverData.NormalCount;
    // 注意件数
    vo.attentionNum = serverData.AttentionCount;
    // 異常件数
    vo.abnormalNum = serverData.AbnormalityCount;
    // ＤＢ更新件数
    vo.updateNum = serverData.DBExecuteCount;
    // 処理件数
    vo.manageNum = serverData.TotalExecuteCount;

    const ref = this.dialogService.openModal(KYMW0D00Component);
    const inst = ref.componentInstance as KYMW0D00Component;

    inst.parent = this;
    inst.setInterfaceParam(vo);

    inst.closeFunction = () => {
      ref.close();
    };
  }

  /**
   * 画像ファイル一覧再取得
   */
  public imageFileListReload(): void {
    // 画像イメージをクリア
    this.img_Publish.nativeElement.src = '';
    this.img_CwsBefore.nativeElement.src = '';
    this.img_CwsAfter.nativeElement.src = '';

    // サーバに画像ファイル一覧取得を要求
    this.getImageFileListService.execute(this.kymw5500Model);
  }
}
